import React from "react";
import classes from "./UserProfilePage.module.css";

const UserProfileSkeleton = () => {
  return <div className={classes.skeleton}></div>;
};

export default UserProfileSkeleton;
